import '../scss/main.scss';

import { initNavigation } from './modules/navigation.js';
import { initBackToTop } from './modules/back-to-top.js';
import { initSwiperCarousel } from './modules/swiper-carousel.js';
import { initEventAccordion } from './modules/event-accordion.js';

document.addEventListener('DOMContentLoaded', () => {
  initNavigation();
  initBackToTop();
  initSwiperCarousel();
  initEventAccordion();
});
